import { memo, useMemo } from "react";
import { useTranslation } from "../../../../hooks";
import {
  BetStatusClassNames,
  BetStatusIconNames,
  BetStatusNames,
  T,
} from "../../../../constants";
import Status from "../status";
import { BetStatus } from "../../../../enums";
import {
  BetShopBetTicketInfoResult,
  BetShopRoundResult,
} from "../../../../models";
import { ReplaceVirtualTranslationKey } from "../../../../helpers";
import { GameIds } from "../../../../constants/games";

interface BetItemProps {
  data: BetShopBetTicketInfoResult;
  openResultSection: (betResult: BetShopRoundResult) => void;
}

const BetItem: React.FC<BetItemProps> = ({ data, openResultSection }) => {
  const t = useTranslation();

  const collectResultData = () => {
    const resultData: any = { ...data.betShopRoundResult };
    if (data.eventName) {
      resultData.eventName = data.eventName;
    }

    openResultSection(resultData);
  };

  const showResultSectionButton = useMemo(() => {
    return Object.values(GameIds).includes(data.betShopRoundResult.gameId);
  }, [data]);

  return (
    <div className="qrTicketGameHolder">
      <div
        className={`qrTicketGameHeader ${BetStatusClassNames[data.betStatus]}`}
      >
        <div className="qrTicketGameHolderInner">
          <span className="qrTicketGameName">{t(data.gameName)} </span>
          <span className="qrTicketGameId">
            ID: {data.leagueDay ? `${t(T.DAY)} ${data.leagueDay} |` : ""}{" "}
            {data.roundId}
          </span>
        </div>
        <Status
          status={BetStatusNames[data.betStatus]}
          icon={BetStatusIconNames[data.betStatus]}
          className={BetStatusClassNames[data.betStatus]}
        />
      </div>
      <div className="qrTicketTeamsCheck">
        {data.eventName ? (
          <span className="qrTicketTeamsNames">{data.eventName}</span>
        ) : null}
        <div className="qrTicketCheckMultiplier">
          <span className="qrTicketCheckMultiplierTxt textThin">
            {t(T.BET)}
          </span>
          <span className="qrTicketTeamsNames">
            {`${ReplaceVirtualTranslationKey(
              t(data.translationSymbols?.marketName || data.marketName),
              data.translationSymbols,
              t,
            )} ${
              data.selectionName || data.translationSymbols?.selectionName
                ? ReplaceVirtualTranslationKey(
                    t(
                      data.translationSymbols?.selectionName ||
                        data.selectionName,
                    ),
                    data.translationSymbols,
                    t,
                  )
                : ""
            }`}
          </span>
        </div>
        <div className="qrTicketCheckMultiplier">
          <span className="qrTicketCheckMultiplierTxt textThin">
            {t(T.STAKE)}
          </span>
          <span className="qrTicketCheckBalanceTxt balance">{`${data.amount} ${data.currencyCode}`}</span>
        </div>
        <div className="qrTicketCheckMultiplier">
          <span className="qrTicketCheckMultiplierTxt textThin">
            {t(T.ODD)}
          </span>
          <span className="qrTicketCheckBalanceTxt textThin">x{data.odd}</span>
        </div>
        <div className="qrTicketCheckMultiplier">
          <span className="qrTicketCheckMultiplierTxt textThin">
            {t(
              data.betStatus === BetStatus.Pending
                ? T.POSSIBLE_WIN
                : T.WINNING_AMOUNT,
            )}
          </span>
          <span className="qrTicketCheckBalanceTxt balance">{`${data.winAmount} ${data.currencyCode}`}</span>
        </div>
      </div>
      {
        showResultSectionButton && (
          <div className="qrTicketCheckMultiplierFooter">
            <div
              className={`qrTicketCheckFooterResult ${data.betStatus === BetStatus.Pending ? "disabled" : null}`}
              onClick={collectResultData}
            >
              <i className="icon-fairnessIcon qrBetsHeaderBtnIcon small"/>
              <span className="qrTicketCheckFooterTxt">{t(T.RESULT)}</span>
            </div>
            <div className="qrTicketCheckFooterButton">
              <i className="icon-right-stroke iconStroke"/>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default memo(BetItem);
